import { ApiClient, getTenantBazaarvoiceConfiguration } from '@ori/static-api-client';
export var resolveHideRating = async function resolveHideRating(_ref) {
  var staticApiUrl = _ref.staticApiUrl,
    tenant = _ref.tenant;
  var client = new ApiClient({
    baseUrl: staticApiUrl
  });
  try {
    var _await$getTenantBazaa = await getTenantBazaarvoiceConfiguration(client, tenant),
      ratingsAndReviewsEnabled = _await$getTenantBazaa.data.ratingsAndReviewsEnabled;
    return !ratingsAndReviewsEnabled;
  } catch (error) {
    // eslint-disable-next-line no-console -- Log error to console.
    console.error(error);
    return true;
  }
};
//# sourceMappingURL=resolveHideRating.js.map